export default "__VITE_ASSET__Rc8lPyqZ__"